import createReactComponent from '../createReactComponent';
export default createReactComponent('ce-off', 'IconCeOff', [
  ['path', { d: 'M11 4a7.99 7.99 0 0 0 -2.581 .426', key: 'svg-0' }],
  ['path', { d: 'M5.867 5.864a8 8 0 0 0 5.133 14.136', key: 'svg-1' }],
  ['path', { d: 'M20 4a8 8 0 0 0 -7.29 4.7', key: 'svg-2' }],
  ['path', { d: 'M12 12a8 8 0 0 0 8 8', key: 'svg-3' }],
  ['path', { d: 'M16 12h4', key: 'svg-4' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-5' }],
]);
